import {useMemo} from "react";
import {ReactComponent as DashboardIcon} from "../../asset/icons/sidebar/dashboard.svg";
import {ReactComponent as ProfileIcon} from "../../asset/icons/sidebar/profile.svg";
import {ReactComponent as MessagesIcon} from "../../asset/icons/sidebar/messages.svg";
import {ReactComponent as ClubIcon} from "../../asset/icons/sidebar/club.svg";
import {ReactComponent as Comment} from "../../asset/icons/sidebar/comment.svg";
import {ReactComponent as Discount} from "../../asset/icons/sidebar/discount.svg";
import {ReactComponent as BasketIcon} from "../../asset/icons/sidebar/basket.svg";
import {useTranslation} from "react-i18next";

function useUserSideBarList() {
  const {t} = useTranslation();

  return useMemo(() => {
    return [
      {
        title: t("User.Overview.label"),
        iconName: <DashboardIcon/>,
        addressLink: "/dashboard/user/dashboard",
      },
      {
        title: t("Messages.label"),
        icon: <MessagesIcon/>,
        iconName: <MessagesIcon/>,
        addressLink: "/dashboard/messages/user",
      },
      {
        title: t("User.Participations.label"),
        iconName: <ClubIcon/>,
        addressLink: "/dashboard/user/customer-club",
      },
      {
        title: t("Surveys&announcments.label"),
        icon: <Comment/>,
        iconName: <Comment/>,
        addressLink: "/dashboard/user/poll",
      },
      {
        title: t("Offers"),
        iconName: <Discount/>,
        addressLink: "/dashboard/user/discount",
      },
      {
        title: t("User.Orders.label"),
        iconName: <BasketIcon/>,
        addressLink: "/dashboard/user/orders",
      },
      {
        title: t("Profile.label"),
        iconName: <ProfileIcon/>,
        addressLink: "/dashboard/user/profile",
      },
    ];
  }, [t]);
}

export default useUserSideBarList;
